import React from 'react'

import {
  Body1,
  Col,
  Grid,
  GridVariant,
  Heading2,
  Link,
  TextAlign,
  Space,
  Heading1,
} from '@gousto-internal/citrus-react'
import Helmet from 'react-helmet'

import policy from 'config/policy'
import { client } from 'config/routes'

import { CookiesPolicy } from './CookiePolicy/CookiesPolicy'
import { Websites } from './Websites'

const PrivacyStatement = () => (
  <Grid variant={GridVariant.Layout}>
    <Col size={12}>
      <Helmet title={policy.head.title} meta={policy.head.meta} />
      <Space size={4} />
      <Heading1 textAlign={TextAlign.Center}>Privacy & Cookies Policy</Heading1>
      <Websites />
      <section id="privacy-policy">
        <Space size={4} />
        <Heading2 textAlign={TextAlign.Center}>Privacy Policy</Heading2>
        <Space size={4} />
        <Body1>
          Want to read all about how we handle your data? Check out the{' '}
          <Link href={client.privacyPolicy}>Gousto Privacy Policy</Link> for everything you need to
          know.
        </Body1>
      </section>
      <CookiesPolicy />
    </Col>
  </Grid>
)

export { PrivacyStatement }
